"use client";

import { motion, AnimatePresence } from "framer-motion";
import { Star } from "lucide-react";
import { useEffect, useState } from "react";

const reviews = [
  {
    text: "David & Sinead Griffith & the Panoptic team provide an excellent service. Attention to detail, clear communication and great post sales support. David's vast IT experience is second to none. Highly recommended.",
    author: "Eoin Campbell",
    role: "Technical Staff",
    company: "Dublin City University",
    rating: 5,
  },
  {
    text: "David and the team have been such a pleasure to work with. They deliver on everything they promise and add great value and direction to all choices being made. We are delighted to have chosen Panoptics as our IT partner to support our business. We would have no hesitation in recommending David and the team.",
    author: "Helen Dooley",
    role: "COO",
    company: "CR Payroll",
    rating: 5,
  },
  {
    text: "Nothing is too much for the team at Panoptic IT. David is fantastic along with the rest of the team who are all highly knowledgeable, helpful and friendly. Highly recommend!",
    author: "Sam Nicholson",
    role: "Recruitment Manager",
    company: "CSA Consultants",
    rating: 5,
  },
  {
    text: "Always amazing service from the team. Really friendly personnel. Super responsive and always have your devices fixed in no time! Superb customer service for our business.",
    author: "Wojciech Lange",
    role: "Owner",
    company: "Perfect Home",
    rating: 5,
  },
];

export const SocialProof = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % reviews.length);
    }, 5000); // Change every 5 seconds

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="container mx-auto px-4 relative">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="lg:absolute relative lg:right-8 lg:-bottom-20 z-20 w-full max-w-md mx-auto lg:mx-0 my-8 lg:my-0"
      >
        <div className="relative bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10">
          {/* Rating Stars */}
          <div className="flex items-center gap-1 mb-4">
            {[...Array(reviews[currentIndex].rating)].map((_, i) => (
              <Star
                key={i}
                className="w-4 h-4 text-[rgb(var(--color-neon-green))]"
                fill="rgb(var(--color-neon-green))"
              />
            ))}
          </div>

          {/* Testimonial */}
          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
            >
              <blockquote className="text-lg font-[450] text-white mb-4">
                "{reviews[currentIndex].text}"
              </blockquote>

              {/* Author Info */}
              <div className="space-y-1">
                <div className="flex items-center gap-2">
                  <span className="text-sm text-[rgb(var(--color-text-secondary))] font-medium">
                    {reviews[currentIndex].author}
                  </span>
                  <div className="h-1 w-1 rounded-full bg-[rgb(var(--color-neon-blue)_/_0.3)]" />
                  <span className="text-sm text-[rgb(var(--color-text-secondary))]">
                    {reviews[currentIndex].role}
                  </span>
                </div>
                <div className="text-sm text-[rgb(var(--color-text-secondary))] opacity-80">
                  {reviews[currentIndex].company}
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Progress Dots - Refactored for performance */}
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2 mt-4">
            {reviews.map((_, index) => (
              <motion.div
                key={index}
                className="h-1.5 w-1.5 rounded-full bg-[rgb(var(--color-neon-green))]"
                initial={false} // Prevent initial animation
                animate={{
                  scale: index === currentIndex ? 2.66 : 1, // Scale active dot (2.66 * 1.5px ≈ 4px width)
                  opacity: index === currentIndex ? 1 : 0.3, // Make inactive dots dimmer
                  // Use transform origin center to scale from the middle if needed
                  // originX: 0.5,
                  // originY: 0.5
                }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
              />
            ))}
          </div>

          {/* Subtle Glow Effect */}
          <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-[rgb(var(--color-neon-blue)_/_0.1)] to-[rgb(var(--color-neon-green)_/_0.1)] opacity-50 pointer-events-none" />
        </div>
      </motion.div>
    </div>
  );
};
